import { storeSearchContract } from '~/services/api/contracts/storeSearchContract'
import {
  SearchCategoriesSuccessSchema,
  SearchDietaryOptionsSuccessSchema,
  SearchPopularTagsSuccessSchema,
  SearchSearchQuerySchema,
  SearchTagsSuccessSchema
} from '~/services/api/generated'
import { searchSearchSuccessCodecSchema, type SearchRequest, type SearchResponse } from './types'
import type {
  SearchCategoriesResponse,
  SearchDietaryOptions,
  SearchPopularTagsResponse,
  SearchTagsResponse
} from './interfaces'

export function useSearchService() {
  const baseURL = `${useRuntimeConfig().public.apiBaseUrl}/api/search`
  const sanctumClient = useApiRequest()

  async function search(params: SearchRequest): Promise<SearchResponse> {
    const query = SearchSearchQuerySchema.strict().parse(params)
    const parsedSearchSuccess = searchSearchSuccessCodecSchema.parse(
      await sanctumClient(`${baseURL}/stores`, {
        method: 'GET',
        params: query
      })
    )
    return storeSearchContract.parse(parsedSearchSuccess)
  }

  async function getPopularTags(): Promise<SearchPopularTagsResponse> {
    const response = SearchPopularTagsSuccessSchema.parse(
      await sanctumClient(`${baseURL}/popular-tags`)
    )
    return storeSearchContract.parsePopularTagsResponse(response)
  }

  async function getCategories(): Promise<SearchCategoriesResponse> {
    const response = SearchCategoriesSuccessSchema.parse(
      await sanctumClient(`${baseURL}/categories`)
    )
    return storeSearchContract.parseCategoriesResponse(response)
  }

  async function getDietaryOptions(): Promise<SearchDietaryOptions> {
    const response = SearchDietaryOptionsSuccessSchema.parse(
      await sanctumClient(`${baseURL}/dietary-options`)
    )
    return storeSearchContract.parseDietaryOptionsResponse(response)
  }

  async function getTags(): Promise<SearchTagsResponse> {
    const response = SearchTagsSuccessSchema.parse(await sanctumClient(`${baseURL}/tags`))
    return storeSearchContract.parseTagsResponse(response)
  }

  return {
    search,
    getPopularTags,
    getCategories,
    getDietaryOptions,
    getTags
  }
}
